<template>
    <div class="MediumEditor u-InputMarginView"
        :class="[modes.map((m) => `MediumEditor--${m}`), { 'MediumEditor--error': isError && required }]">
        <span class="MediumEditorViewRequired" v-if="required">*</span>
        <label class="MediumEditorLabel" :for="`MediumEditor-input-${_uid}`" v-if="title">
            <p>{{ title }}</p>
            <p>Встроенный редактор</p>
        </label>
        <editor class="MediumEditorInput" :id="`MediumEditor-input-${_uid}`"
            :style="{ minHeight: minHeight, maxWidth: maxWidth, minWidth: minWidth, height: height }" :text="innerValue"
            :options="options" :placeholder="placeholder" @edit="checkChange" />
    </div>
</template>

<script>
import editor from 'vue2-medium-editor';

export default {
    name: 'MediumEditor',
    mixins: [mixins.ValidationComponentMixin],
    components: {
        'editor': editor
    },
    computed: {
        toolbarButtons() {
            // default 
            if (this.type === '') {
                return [
                    // {
                    //     name: 'bold',
                    //     contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-bold"><use xlink:href="${this.static('svg/sprite.symbol.svg#bold')}"></use></svg>`
                    // },
                    // {
                    //     name: 'italic',
                    //     contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-italic"><use xlink:href="${this.static('svg/sprite.symbol.svg#italic')}"></use></svg>`
                    // },
                    {
                        name: 'anchor',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-link"><use xlink:href="${this.static('svg/sprite.symbol.svg#link')}"></use></svg>`,
                    },
                    {
                        name: 'orderedlist',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-ol"><use xlink:href="${this.static('svg/sprite.symbol.svg#ol')}"></use></svg>`
                    },
                    {
                        name: 'unorderedlist',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-ul"><use xlink:href="${this.static('svg/sprite.symbol.svg#ul')}"></use></svg>`,
                        attrs: {
                            'type': 'circle'
                        }
                    },
                    {
                        name: 'indent',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-list"><use xlink:href="${this.static('svg/sprite.symbol.svg#list-right')}"></use></svg>`
                    },
                    {
                        name: 'outdent',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-list"><use xlink:href="${this.static('svg/sprite.symbol.svg#list-left')}"></use></svg>`
                    },
                    {
                        name: 'removeFormat',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-eraser"><use xlink:href="${this.static('svg/sprite.symbol.svg#eraser')}"></use></svg>`,
                    },
                ];
            }

            if (this.type === 'link') {
                return [
                    {
                        name: 'anchor',
                        contentDefault: `<svg class="MediumEditorIcon MediumEditorIcon-link"><use xlink:href="${this.static('svg/sprite.symbol.svg#link')}"></use></svg>`,
                    },
                ];
            }
        },
        options() {
            return {
                placeholder: this.placeholder ? { text: this.placeholder, hideOnClick: false } : false,
                paste: {
                    forcePlainText: true,
                    cleanPastedHTML: true,
                    cleanReplacements: [],
                    cleanAttrs: ['class', 'style', 'dir', 'strong', 'p'],
                    cleanTags: ['meta']
                },
                toolbar: {
                    buttons: this.toolbarButtons,
                },
                elementContainer: 'div',
                targetBlank: true,
                anchorPreview: {
                    hideDelay: 500,
                },
            };
        }
    },
    props: {
        title: { type: String, default: '' },
        required: { type: Boolean, default: false },
        value: { type: [Object, String], default: '' },
        minHeight: { type: String, default: '40px' },
        maxWidth: { type: String, default: '100%' },
        minWidth: { type: String, default: '100%' },
        marginBottom: { type: String, default: '0' },
        marginTop: { type: String, default: '' },
        height: { type: String, default: '' },
        modes: { type: Array, default: () => [] },
        editorMode: { type: String, default: '' },
        placeholder: { type: [Boolean, String], default: 'Teкст' },
        config: { type: String, default: 'default' },
        isError: { type: Boolean, default: false },
        type: { type: String, default: '' }
    },

    methods: {
        checkChange($event) {
            let newValue = $event.api.origElements.innerHTML;
            const el = document.createElement('div');

            el.innerHTML = newValue;
            if (!el.textContent) {
                newValue = '';
            }

            if (this.innerValue !== newValue) {
                this.innerValue = newValue
            }
        },
    }
};
</script>

<style lang="less">
@import "~styles/const.less";

@r: .MediumEditor;

@{r} {
    position: relative;
    margin-top: 25px;
    width: 100%;

    &Required {
        color: #A6A6A6;
        position: absolute;
        top: 20px;
        left: -23px;
    }

    &Label {
        display: flex;
        justify-content: space-between;
        color: black;
        font-size: 12px;
        line-height: 16px;

        >p {
            margin: 0;
        }
    }

    &Input {
        display: block;
        min-width: 710px;
        width: 100%;
        outline: none;
        border: 1px solid #B3B3B3;
        font-weight: normal;
        font-family: @Graphik-LCG;
        font-size: 12px;
        line-height: 16px;
        padding: 12px 15px;
        margin: 10px 0 0;
        color: @color-black;

        p {
            margin: 0 0 10px;
            font-size: 12px;
            line-height: 16px;

            &:last-child {
                margin: 0;
            }
        }

        a {
            color: black;
            border-bottom: 1px solid black;
            text-decoration: none;
            font-size: 12px;
            line-height: 16px;
        }

        ul {
            padding-left: 15px;
            list-style-type: disc;

            >li {
                position: relative;
                padding-left: 3px;
                margin: 0 0 10px;
                font-size: 12px;
                line-height: 16px;
            }
        }

        ol {
            padding-left: 18px;

            >li {
                position: relative;
                padding-left: 3px;
                margin: 0 0 10px;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }

    &--error {
        .TextareaViewRequired {
            color: @color-red;
        }

        .TextareaViewInput {
            border-bottom-color: @color-red;
        }
    }

    &Icon {
        fill: white;
        height: 12px;

        &-bold {
            width: 9px;
        }

        &-italic {
            width: 6px;
        }

        &-link {
            width: 27px;
        }

        &-ol {
            width: 36px;
        }

        &-ul {
            width: 30px;
        }

        &-list {
            width: 36px;
        }

        &-eraser {
            width: 13px;
        }

        .medium-editor-button-active & {
            fill: @color-link;
        }

        .medium-editor-toolbar li button:hover & {
            fill: @color-link;
        }
    }

    &--stats {
        overflow: hidden;

        .MediumEditorInput {
            font-size: 20px;
            line-height: 20px;
            letter-spacing: -0.02em;
            border-bottom: 1px solid @color-black;
            min-height: 50px !important;
            max-height: 50px !important;
            overflow: scroll;
            display: grid;
            align-items: center;

            p {
                margin: 0;
            }

            &:after {
                top: 10px;
            }
        }
    }
}

.medium-editor-toolbar {
    background: @color-black !important;
    border-radius: 0 !important;
    padding: 0 0 0 20px !important;
    height: 30px !important;

    >ul {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        gap: 20px !important;
    }
}

.medium-editor-toolbar li button.medium-editor-action {
    display: flex;
    justify-content: center;
    align-items: center;
}

.medium-editor-anchor-preview a {
    margin: 5px 5px 7px;
}

.medium-toolbar-arrow-under:after {
    border-width: 0 !important;
}

.medium-editor-toolbar li button {
    background: @color-black !important;
    padding: 0 !important;
    height: 10px !important;
    min-width: auto !important;
    padding: 15px 0 8px !important;
}

.medium-editor-placeholder-relative:after,
.medium-editor-placeholder:after {
    margin: 0 !important;
    padding: inherit !important;
    font-style: inherit !important;
    font-weight: inherit !important;
    color: @color-placeholder !important;
}
</style>
